export const hasCookie = (name) => typeof document !== 'undefined' && document.cookie.includes(name);
